{
  "id": "33cfr62",
  "title": "United States Aids to Navigation System, 33 CFR Part 62",
  "region": "B",
  "url": "https://www.ecfr.gov/current/title-33/chapter-I/subchapter-C/part-62",
  "retrieved": "2026-09-19",
  "license": "US Government Work, gemeinfrei (17 U.S.C. 105)",
  "sections": {
    "62.1": {
      "id": "62.1",
      "heading": "Purpose.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) The Coast Guard administers the U.S. Aids to Navigation System. The system consists of Federal aids to navigation operated by the Coast Guard, aids to navigation operated by the other armed services, and private aids to navigation operated by other persons."
        },
        {
          "id": "b",
          "text": "(b) This part describes the general characteristics of the U.S. Aids to Navigation System, and the details, policies and procedures employed by the Coast Guard in establishing, maintaining, operating, changing or discontinuing Federal aids to navigation. Regulations concerning the marking of wrecks, structures, and other obstructions are found in 33 CFR part 64. Regulations concerning private aids are found in 33 CFR part 66. Regulations concerning the marking of artificial islands and structures which are erected on or over the seabed and subsoil of the Outer Continental Shelf of the United States or its possessions are found in 33 CFR part 67. Regulations concerning the marking of bridges are found in 33 CFR part 118. Regulations concerning aids to navigation at deepwater ports are found in subchapter NN of this chapter."
        },
        {
          "id": "c",
          "text": "(c) The Coast Guard maintains systems of marine aids to navigation consisting of visual, audible, and electronic signals which are designed to assist the prudent mariner in the process of navigation. The aids to navigation system is not intended to identify every shoal or obstruction to navigation which exists in the navigable waters of the United States, but rather provides for reasonable marking of marine features as resources permit. The primary objective of the aids to navigation system is to mark navigable channels and waterways, obstructions adjacent to these waterways, and obstructions in areas of general navigation which may not be anticipated. Other waters, even if navigable, are generally not marked."
        }
      ]
    },
    "62.3": {
      "id": "62.3",
      "heading": "Definition of terms.",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Certain terms as used in this subchapter are defined as follows:"
        },
        {
          "id": "a",
          "text": "(a) Aid to Navigation. The term aid to navigation means any device external to a vessel or aircraft intended to assist a navigator to determine position or safe course, or to warn of dangers or obstructions to navigation."
        },
        {
          "id": "b",
          "text": "(b) Commerce. The term commerce, in addition to general, national and international trade and commerce of the United States, includes trade and travel by seasonal passenger craft (marine and air), yachts, houseboats, fishing boats, motor boats, and other craft, whether or not operated for hire or profit."
        },
        {
          "id": "c",
          "text": "(c) Commandant. The term Commandant means the Commandant of the Coast Guard."
        },
        {
          "id": "d",
          "text": "(d) District Commander. The term District Commander means the commander of a Coast Guard District. Coast Guard Districts are listed in Part 3 of this chapter."
        },
        {
          "id": "e",
          "text": "(e) Corps of Engineers. The term Corps of Engineers means the Corps of Engineers, Department of the Army."
        },
        {
          "id": "f",
          "text": "(f) Person. The term person imparts both singular or plural, as the case demands, and includes any Federal Agency, State, Territory, possession, or public subdivision thereof, the District of Columbia, and any corporation, company, association, club, or other instrumentality."
        },
        {
          "id": "g",
          "text": "(g) Navigable waters of the United States. The term navigable waters of the United States is defined in § 2.36(a) of this chapter."
        }
      ]
    },
    "62.5": {
      "id": "62.5",
      "heading": "Marking of marine parades and regattas.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) The Coast Guard may establish aids to navigation to mark marine parades and regattas which are regulated by the Coast Guard for the purpose of protecting life and property, or to assist in the observance and enforcement of special regulations. For marine parade and regatta regulations, see Part 100 of this chapter."
        },
        {
          "id": "b",
          "text": "(b) [Reserved]"
        }
      ]
    },
    "62.21": {
      "id": "62.21",
      "heading": "General.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) The navigable waters of the United States and non-navigable State waters after December 31, 2003, are marked to assist navigation using the U.S. Aids to Navigation System, a system consistent with the International Association of Lighthouse Authorities (IALA) Maritime Buoyage System. The IALA Maritime Buoyage System is followed by most of the world's maritime nations and will improve maritime safety by encouraging conformity in buoyage systems worldwide. IALA buoyage is divided into two regions made up of Region A and Region B. All navigable waters of the United States follow IALA Region B, except U.S. possessions west of the International Date Line and south of 10 degrees north latitude, which follow IALA Region A. Lateral aids to navigation in Region A vary from those described throughout this Subpart. Non-lateral aids to navigation are the same as those used in Region B. See § 62.25. Appropriate nautical charts and publications should be consulted to determine whether the Region A or Region B marking schemes are in effect for a given area."
        },
        {
          "id": "b",
          "text": "(b) The U.S. Aids to Navigation System is designed for use with nautical charts. Nautical charts portray the physical features of the marine environment, including soundings and other submarine features, landmarks, and other aids necessary for the proper navigation of a vessel. This crucial information cannot be obtained from other sources, even ones such as topographic maps, aeronautical charts, or atlases. The exact meaning of an aid to navigation may not be clear to the mariner unless the appropriate chart is consulted, as the chart illustrates the relationship of the individual aid to navigation to channel limits, obstructions, hazards to navigation, and to the total aids to navigation system."
        },
        {
          "id": "c",
          "text": "(c) The navigator should maintain and consult suitable publications and instruments for navigation depending on the vessel's requirements. This shipboard equipment is separate from the aids to navigation system, but is often essential to its use. The following publications are available from the U.S. Government to assist the navigator:"
        },
        {
          "id": "c(1)",
          "text": "(1) The Light List, published by the Coast Guard and available for viewing on the Coast Guard Navigation Center Web site at http://www.navcen.uscg.gov lists federal and private aids to navigation. It includes all major Federal aids to navigation and those private aids to navigation that have been deemed to be important to general navigation, and includes a physical description of these aids and their locations."
        },
        {
          "id": "c(2)",
          "text": "(2) The United States Coast Pilot, published by the National Ocean Service and available from NOAA Certified Printer Partners listed at www.nauticalcharts.noaa.gov/enconline/enconline.html. Free on-line versions and weekly updates supplement the information shown on nautical charts and are available directly from NOAA at distribution.charts.noaa.gov/weekly_updates/. Subjects such as local navigation regulations, channel and anchorage peculiarities, dangers, climatological data, routes, and port facilities are covered."
        },
        {
          "id": "c(3)",
          "text": "(3) Local Notices to Mariners are published by local Coast Guard District Commanders. Persons may view Local Notices to Mariners on the Coast Guard Navigation Center Web site at http://www.navcen.uscg.gov. Changes to aids to navigation, reported dangers, scheduled construction or other disruptions, chart corrections and similar useful marine information is made available through this publication."
        },
        {
          "id": "c(4)",
          "text": "(4) The Notice to Mariners is a national publication, similar to the Local Notice to Mariners, published by the National Geospatial-Intelligence Agency. The notices may be viewed on the National Geospatial-Intelligence Agency's Web site at http://msi.nga.mil/NGAPortal/MSI.portal. This publication provides oceangoing vessels significant information on national and international navigation and safety."
        },
        {
          "id": "c(5)",
          "text": "(5) The mariner should also listen to Coast Guard Broadcast Notices to Mariners. These broadcasts update the Local Notice to Mariners with more timely information. Mariners should monitor VHF-FM channel 16 to locate Coast Guard Marine Information Broadcasts."
        },
        {
          "id": "d",
          "text": "(d) The U.S. Aids to Navigation System is primarily a lateral system which employs a simple arrangement of colors, shapes, numbers, and light characteristics to mark the limits of navigable routes. This lateral system is supplemented by nonlateral aids to navigation where appropriate."
        },
        {
          "id": "e",
          "text": "(e) Generally, lateral aids to navigation indicate on which side of a vessel an aid to navigation should be passed when the vessel is proceeding in the Conventional Direction of Buoyage. Normally, the Conventional Direction of Buoyage is the direction in which a vessel enters navigable channels from seaward and proceeds towards the head of navigation. In the absence of a route leading from seaward, the Conventional Direction of Buoyage generally follows a clockwise direction around land masses. For example, proceeding southerly along the Atlantic Coast, from Florida to Texas along the Gulf Coast, and northerly along the Pacific Coast are considered as proceeding in the Conventional Direction of Buoyage. In some instances, this direction must be arbitrarily assigned. Where doubt exists, the mariner should consult charts and other nautical publications."
        },
        {
          "id": "f",
          "text": "(f) Although aids to navigation are maintained to a reasonable degree of reliability, the rigors of the marine environment and various equipment failures do cause discrepancies on occasion."
        },
        {
          "id": "g",
          "text": "(g) The Coast Guard makes reasonable efforts to inform the navigator of known discrepancies, and to correct them within a reasonable period of time, depending upon resources available. Occasionally, a temporary aid to navigation, which provides different but similar service, is deployed until permanent repairs can be made to the original aid. Notification of such temporary changes is made through the notice to mariners system."
        },
        {
          "id": "h",
          "text": "(h) Mariners should exercise caution when using private aids to navigation because private aids are often established to serve the needs of specific users rather than general navigation and their purpose may not be obvious to casual users; and, discrepancies to private aids are often detected, reported, and corrected less promptly than discrepancies to Coast Guard aids to navigation."
        }
      ]
    },
    "62.23": {
      "id": "62.23",
      "heading": "Beacons and buoys.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Aids to navigation are placed on shore or on marine sites to assist a navigator to determine his position or safe course. They may mark limits of navigable channels, or warn of dangers or obstructions to navigation. The primary components of the U.S. Aids to Navigation System are beacons and buoys."
        },
        {
          "id": "b",
          "text": "(b) Beacons are aids to navigation structures which are permanently fixed to the earth's surface. They range from large lighthouses to small, single-pile structures and may be located on land or in the water. Lighted beacons are called lights; unlighted beacons are called daybeacons."
        },
        {
          "id": "b(1)",
          "text": "(1) Beacons exhibit a daymark. For small structures these are colored geometric shapes which make an aid to navigation readily visible and easily identifiable against background conditions. Generally, the daymark conveys to the mariner, during daylight hours, the same significance as does the aid's light or reflector at night. The daymark of large lighthouses and towers, however, consists of the structure itself. As a result, these daymarks do not infer lateral significance."
        },
        {
          "id": "b(2)",
          "text": "(2) Vessels should not pass beacons close aboard due to the danger of collision with rip-rap or structure foundations, or the obstruction or danger that the aid marks."
        },
        {
          "id": "c",
          "text": "(c) Buoys are floating aids to navigation used extensively throughout U.S. waters. They are moored to the seabed by sinkers with chain or other moorings of various lengths."
        },
        {
          "id": "c(1)",
          "text": "(1) The daymark of a buoy is the color and shape of the buoy and, if so equipped, of the topmark."
        },
        {
          "id": "i",
          "text": "(i) Can buoys have a cylindrical shape."
        },
        {
          "id": "i.7",
          "text": "(ii) Nun buoys have a tapered, conical shape."
        },
        {
          "id": "i.8",
          "text": "(iii) Pillar buoys have a wide cylindrical base supporting a narrower superstructure. They may be surmounted by colored shapes called topmarks."
        },
        {
          "id": "i.9",
          "text": "(iv) Spherical buoys have a round shape."
        },
        {
          "id": "i(2)",
          "text": "(2) Mariners attempting to pass a buoy close aboard risk collision with a yawing buoy, the buoy's mooring, or with the obstruction which the buoy marks."
        },
        {
          "id": "i(3)",
          "text": "(3) Mariners should not rely on buoys alone for determining their positions due to factors limiting their reliability. Prudent mariners will use bearings or angles from beacons or other landmarks, soundings, and various methods of electronic navigation. Buoys vary in reliability because:"
        },
        {
          "id": "i",
          "text": "(i) Buoy positions represented on nautical charts are approximate positions only, due to practical limitations in positioning and maintaining buoys and their sinkers in precise geographical locations."
        },
        {
          "id": "i.13",
          "text": "(ii) Buoy moorings vary in length. The mooring lengths define a “watch circle”, and buoys can be expected to move within this circle. Actual watch circles do not coincide with the dots or circles representing them on charts."
        },
        {
          "id": "i.14",
          "text": "(iii) Buoy positions are normally verified during periodic maintenance visits. Between visits, environmental conditions, including atmospheric and sea conditions, and seabed slope and composition, may shift buoys off their charted positions. Also buoys may be dragged off station, sunk, or capsized by a collision with a vessel."
        }
      ]
    },
    "62.25": {
      "id": "62.25",
      "heading": "Lateral marks.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Lateral marks define the port and starboard sides of a route to be followed. They may be either beacons or buoys."
        },
        {
          "id": "b",
          "text": "(b) Sidemarks are lateral marks which advise the mariner to stay to one side of the mark. Their most frequent use is to mark the sides of channels; however, they may be used individually to mark obstructions outside of clearly defined channels. Sidemarks are not always placed directly on a channel edge and may be positioned outside the channel as indicated on charts and nautical publications."
        },
        {
          "id": "b(1)",
          "text": "(1) Port hand marks indicate the left side of channels when proceeding in the Conventional Direction of Buoyage. Beacons have green square daymarks, while buoys are green can or pillar buoys."
        },
        {
          "id": "b(2)",
          "text": "(2) Starboard hand marks indicate the right side of channels when proceeding in the Conventional Direction of Buoyage. Beacons have red triangular daymarks, while buoys are red nun or pillar buoys."
        },
        {
          "id": "c",
          "text": "(c) Preferred channel marks indicate channel junctions or bifurcations and may also mark wrecks or obstructions which the mariner, after consulting a chart to ascertain the location of the obstruction relative to the aid, may pass on either side. Preferred channel marks have red and green horizontal bands with the color of the topmost band indicating the preferred channel. If the topmost band is green, the mark serves as a port hand mark for vessels following the preferred channel proceeding in the Conventional Direction of Buoyage, and as a starboard hand mark for the other channel. Beacons would have square daymarks, while buoys would be can or pillar buoys. If the topmost band is red, the mark serves as a starboard hand mark for vessels following the preferred channel proceeding in the Conventional Direction of Buoyage, and a port hand mark for the other channel. Beacons would have triangular daymarks, while buoys would be nun or pillar buoys."
        },
        {
          "id": "d",
          "text": "(d) The above color schemes apply to IALA Region B. Marks located in the IALA Region A exhibit reversed color significance: port hand marks will be red when following the Conventional Direction of Buoyage, and starboard hand marks will be green. The meaning of daymark and buoy shapes is identical in both regions."
        },
        {
          "id": "e",
          "text": "(e) Certain marks on the Intracoastal Waterway may exhibit reversed lateral significance. See § 62.49."
        }
      ]
    },
    "62.27": {
      "id": "62.27",
      "heading": "Safe water marks.",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Safe water marks indicate that there is navigable water all around the mark. They are often used to indicate fairways or midchannels, or the seaward end of channels. Safe water marks are colored with red and white vertical stripes. Beacons have an octagonal daymark; red and white buoys are spherical or display a red spherical topmark."
        }
      ]
    },
    "62.29": {
      "id": "62.29",
      "heading": "Isolated danger marks.",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Isolated danger marks indicate an isolated danger which may be passed on all sides. As these marks are erected or moored on or near dangers, they should not be approached closely without special caution. These marks are colored black with one or more broad horizontal red bands and are equipped with a topmark of two black spheres, one above the other."
        }
      ]
    },
    "62.31": {
      "id": "62.31",
      "heading": "Special marks.",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Special marks are not primarily intended to assist safe navigation, but to indicate special areas or features referred to in charts or other nautical publications. They may be used, for example, to mark anchorages, cable or pipeline areas, traffic separation schemes, military exercise zones, ocean data acquisition systems, etc. Special marks are colored solid yellow."
        }
      ]
    },
    "62.32": {
      "id": "62.32",
      "heading": "Inland waters obstruction mark.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) On inland waters designated by the Commandant as State waters in accordance with § 66.05-5 of this chapter and on non-navigable internal waters of a State which have no defined head of navigation, a buoy showing alternate vertical black and white stripes may be used to indicate to a vessel operator that an obstruction to navigation extends from the nearest shore to the buoy."
        },
        {
          "id": "b",
          "text": "(b) The black and white buoy's meaning is “do not pass between the buoy and the shore”. The number of white and black stripes is discretionary, provided that the white stripes are twice the width of the black stripes. Prior to December 31, 2003, this aid shall not be used on a waterway which has a red and white striped obstruction marker defined in § 66.10-15(e)(3) of this chapter, unless all obstruction markers are replaced."
        }
      ]
    },
    "62.33": {
      "id": "62.33",
      "heading": "Information and regulatory marks.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Information and Regulatory Marks are used to alert the mariner to various warnings or regulatory matters. These marks have orange geometric shapes against a white background. The meanings associated with the orange shapes are as follows:"
        },
        {
          "id": "a(1)",
          "text": "(1) A vertical open-faced diamond signifies danger."
        },
        {
          "id": "a(2)",
          "text": "(2) A vertical diamond shape having a cross centered within indicates that vessels are excluded from the marked area."
        },
        {
          "id": "a(3)",
          "text": "(3) A circular shape indicates that certain operating restrictions are in effect within the marked area."
        },
        {
          "id": "a(4)",
          "text": "(4) A square or rectangular shape will contain directions or instructions lettered within the shape."
        },
        {
          "id": "b",
          "text": "(b) When a buoy is used as an information or regulatory mark it shall be white with two horizontal orange bands placed completely around the buoy circumference. One band shall be near the top of the buoy body, with a second band placed just above the waterline of the buoy so that both bands are clearly visible."
        }
      ]
    },
    "62.35": {
      "id": "62.35",
      "heading": "Mooring buoys.",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Mooring Buoys are white with a blue horizontal band. This distinctive color scheme is recommended to facilitate identification and to avoid confusion with aids to navigation."
        }
      ]
    },
    "62.37": {
      "id": "62.37",
      "heading": "Lighthouses.",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Lighthouses are prominent beacons of varying size, color, and appearance employed to mark headlands, landfalls, harbor entrances, channel edges, hazards, and other features. While normally identified by their distinctive appearance, some lighthouses display diamond shaped, checkered daymarks to facilitate recognition."
        }
      ]
    },
    "62.41": {
      "id": "62.41",
      "heading": "Ranges.",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Ranges are aids to navigation systems employing dual beacons which, when the structures appear to be in line, assist the mariner in maintaining a safe course. The appropriate nautical chart must be consulted when using ranges to determine whether the range marks the centerline of the navigable channel and also to ascertain what section of the range may be safety traversed. Ranges are generally, but not always, lighted, and display rectangular daymarks of various colors."
        }
      ]
    },
    "62.43": {
      "id": "62.43",
      "heading": "Numbers and letters.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) All solid red and solid green aids are numbered, with red aids bearing even numbers and green aids bearing odd numbers. The numbers for each increase in the Conventional Direction of Buoyage. Numbers are kept in approximately sequence on both sides of the channel by omitting numbers where necessary."
        },
        {
          "id": "b",
          "text": "(b) Only sidemarks are numbered. However, aids other than those mentioned above may be lettered to assist in their identification, or to indicate their purpose. Sidemarks may carry letters in addition to numbers to identify the first aid to navigation in a waterway, or when new aids to navigation are added to channels with previously completed numerical sequences. Letters on sidemarks will follow alphabetical order from seaward and proceeding toward the Conventional Direction of Buoyage and will be added to numbers as suffixes."
        },
        {
          "id": "c",
          "text": "(c) Aids to navigation may be fitted with light-reflecting material to increase their visibility in darkness. The colors of this material may convey the same significance as the aid except that letters and numbers may be white."
        },
        {
          "id": "d",
          "text": "(d) Exceptions to the provisions of this section will be found on the Western Rivers System. See § 62.51."
        },
        {
          "id": "e",
          "text": "(e) The guidelines for the display of numbers and letters on aids to navigation are identical for both Region A and Region B; red aids to navigation display even numbers, and green aids display odd numbers."
        }
      ]
    },
    "62.45": {
      "id": "62.45",
      "heading": "Light characteristics.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Lights on aids to navigation are differentiated by color and rhythm. Lighthouses and range lights may display distinctive light characteristics to facilitate recognition. No special significance should be attached to the color or rhythm of such lights. Other lighted aids to navigation employ light characteristics to convey additional information."
        },
        {
          "id": "b",
          "text": "(b) When proceeding in the Conventional Direction of Buoyage, aids to navigation, if lighted, display light characteristics as follows:"
        },
        {
          "id": "b(1)",
          "text": "(1) Green lights mark port (left) sides of channels and locations of wrecks or obstructions which are to be passed by keeping these lights on the port (left) hand of a vessel. Green lights are also used on Preferred Channel Marks where the topmost band is green."
        },
        {
          "id": "b(2)",
          "text": "(2) Red lights mark starboard (right) sides of channels and locations of wrecks or obstructions which are to be passed by keeping these lights on the starboard (right) hand of a vessel. Red lights are also used on Preferred Channel Marks where the topmost band is red."
        },
        {
          "id": "b(3)",
          "text": "(3) Certain lights marking the Intracoastal Waterway may display reversed lateral significance. See § 62.49."
        },
        {
          "id": "c",
          "text": "(c) Yellow lights have no lateral significance. Except on the Western Rivers, see § 62.51, white lights have no lateral significance. The purpose of aids exhibiting white or yellow lights may be determined by their shape, color, letters or numbers, and the light rhythm employed."
        },
        {
          "id": "d",
          "text": "(d) Light rhythms, except as noted in § 62.51 for the Western Rivers, are employed as follows:"
        },
        {
          "id": "d(1)",
          "text": "(1) Aids with lateral significance display regularly flashing or regularly occulting light rhythms. Ordinarily, flashing lights (frequency not exceeding 30 flashes per minute) will be used."
        },
        {
          "id": "d(2)",
          "text": "(2) Preferred Channel Marks display a composite group flashing light rhythm (groups of two flashes followed by one flash)."
        },
        {
          "id": "d(3)",
          "text": "(3) Safe Water Marks display a white Morse Code “A” rhythm (short-long flash)."
        },
        {
          "id": "d(4)",
          "text": "(4) Isolated Danger Marks display a white group flashing two."
        },
        {
          "id": "d(5)",
          "text": "(5) Special Marks display yellow lights with fixed or slow flashing rhythm preferred."
        },
        {
          "id": "d(6)",
          "text": "(6) Mooring Buoys and Information and Regulatory Marks display white lights of various rhythms."
        },
        {
          "id": "d(7)",
          "text": "(7) For situations where lights require a distinct cautionary significance, as at sharp turns, sudden channel constrictions, wrecks, or obstructions, a quick flashing light rhythm (60 flashes per minute) may be used."
        },
        {
          "id": "e",
          "text": "(e) Occasionally lights use sectors to mark shoals or warn mariners of other dangers. Lights so equipped show one color from most directions and a different color or colors over definite arcs of the horizon as indicated on the appropriate nautical chart. These sectors provide approximate bearing information since the observer should note a change of color as the boundary between the sectors is crossed. As sector bearings are not precise, they should be considered a warning only and not used to determine exact bearing to the light."
        },
        {
          "id": "f",
          "text": "(f) Aids to navigation may be fitted with light-reflecting material to increase their visibility in darkness. Green or red reflective material is used only on marks which, if lighted, would exhibit a light of that color. Yellow reflective material is used on special marks and on Intracoastal Waterway marks. No significance is attached to white reflective material."
        }
      ]
    },
    "62.47": {
      "id": "62.47",
      "heading": "Sound signals.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Often sound signals are located on or adjacent to aids to navigation. When visual signals are obscured, sound signals warn mariners of the proximity of danger."
        },
        {
          "id": "a(1)",
          "text": "(1) Sound signals are distinguished by their tone and phase characteristics."
        },
        {
          "id": "i",
          "text": "(i) Tones are determined by the devices producing the sound (i.e., diaphones, diaphragm horns, reed horns, sirens, whistles, bells and gongs)."
        },
        {
          "id": "i.3",
          "text": "(ii) Phase characteristics are defined by the signal's sound pattern, i.e., the number of blasts and silent periods per minute and their durations. Sound signals emanating from fixed structures generally produce a specific number of blasts and silent periods each minute when operating. Buoy sound signals are generally actuated by the motion of the sea and therefore do not emit a regular signal characteristic."
        },
        {
          "id": "i(2)",
          "text": "(2) Where no live watch is maintained, sound signals are normally operated continuously. However, most are equipped with Mariner Radio Activated Sound Systems (MRASS) that are activated by the mariner by keying their VHF radio microphone five (5) times on the designated charted frequency. Channels 81a (157.075 MHz) and channel 83a (157.175 MHz) are the two most common frequencies, but others may be designated and charted. (Mariners may consult the appropriate U.S. Coast Guard Light List volume or local notice to mariners for specific activation frequencies and instructions.) Activated signals will normally operate for 45 minutes after the signal is triggered."
        },
        {
          "id": "b",
          "text": "(b) Mariners should not rely solely on sound signals to determine their positions for the following reasons:"
        },
        {
          "id": "b(1)",
          "text": "(1) Distance cannot be accurately determined by sound intensity."
        },
        {
          "id": "b(2)",
          "text": "(2) Occasionally sound signals may not be heard in areas close to their location."
        },
        {
          "id": "b(3)",
          "text": "(3) Signals may not sound in cases where fog exists close to, but not at, the location of the sound signal."
        },
        {
          "id": "b(4)",
          "text": "(4) As buoy signals are generally activated by sea motion, they may produce no signals when seas are calm."
        },
        {
          "id": "b(5)",
          "text": "(5) As previously noted, buoy positions are not always reliable. Therefore their sound signals cannot be assumed to be emanating from a fixed position."
        }
      ]
    },
    "62.49": {
      "id": "62.49",
      "heading": "Intracoastal Waterway identification.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) In addition to the conventional signals, aids to navigation marking the Intracoastal Waterway exhibit unique yellow symbols to distinguish them from aids marking other waters."
        },
        {
          "id": "a(1)",
          "text": "(1) Yellow triangles indicate that aids to navigation so marked should be passed keeping them on the starboard (right) hand of a vessel, regardless of the aid's number, color, or light color."
        },
        {
          "id": "a(2)",
          "text": "(2) Yellow squares indicate that aids to navigation so marked should be passed keeping them on the port (left) hand of a vessel, regardless of the aid's number, color, or light color."
        },
        {
          "id": "a(3)",
          "text": "(3) A horizontal yellow band provides no lateral information, but simply identifies aids to navigation as marking the Intracoastal Waterway."
        },
        {
          "id": "b",
          "text": "(b) The above guidelines apply for vessels traversing the Intracoastal Waterway in a southerly direction on the Atlantic Coast, in a westerly direction on the Okeechobee Waterway, or in a westerly direction along the Gulf Coast."
        }
      ]
    },
    "62.51": {
      "id": "62.51",
      "heading": "Western Rivers Marking System.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A variation of the standard U.S. aids to navigation system described above is employed on the Mississippi River and tributaries above Baton Rouge, LA and on certain other rivers which flow toward the Gulf of America."
        },
        {
          "id": "b",
          "text": "(b) The Western Rivers System varies from the standard U.S. system as follows:"
        },
        {
          "id": "b(1)",
          "text": "(1) Buoys are not numbered."
        },
        {
          "id": "b(2)",
          "text": "(2) Numbers on beacons do not have odd/even lateral significance but, rather, indicate mileage from a fixed point (normally the river mouth)."
        },
        {
          "id": "b(3)",
          "text": "(3) Diamond-shaped non-lateral dayboards, checkered red-and-white or green-and-white, similar to those used in the U.S. Aids to Navigation System, as appropriate, are used as crossing dayboards where the river channel crosses from one bank to the other."
        },
        {
          "id": "b(4)",
          "text": "(4) Lights on green buoys and on beacons with green daymarks show a single flash which may be green or white."
        },
        {
          "id": "b(5)",
          "text": "(5) Lights on red buoys and on beacons with red daymarks show a double flash [Group Flashing (2)] which may be red or white."
        },
        {
          "id": "b(6)",
          "text": "(6) Isolated danger marks are not used."
        }
      ]
    },
    "62.52": {
      "id": "62.52",
      "heading": "Automatic Identification System Aids to Navigation (AIS AtoN).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Aids to Navigation (AtoN) may be enhanced by the use of an automatic identification system (AIS). AIS is a maritime navigation safety communications protocol standardized by the International Telecommunication Union and adopted by the International Maritime Organization for the broadcast or exchange of navigation information between vessels, aircraft, and shore stations. AIS AtoN can autonomously and at fixed intervals broadcast the name, position, dimensions, type, characteristics and status from or concerning an aid to navigation."
        },
        {
          "id": "b",
          "text": "(b) AIS AtoN can be either physical (fitted to the AtoN), synthetic (physically fitted somewhere other than to the AtoN) or virtual (physically nonexistent, but capable of being portrayed on AIS-capable displays)."
        },
        {
          "id": "c",
          "text": "(c) AIS AtoN can also be used to broadcast both laterally ( e.g., Port Hand Mark) and non-laterally significant marine safety information ( e.g., environmental data, tidal information, and navigation warnings)."
        }
      ]
    },
    "62.53": {
      "id": "62.53",
      "heading": "Racons.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Aids to navigation may be enhanced by the use of radar beacons (racons). Racons, when triggered by a radar signal, will transmit a coded reply to the interrogating radar. This reply serves to identify the aid station by exhibiting a series of dots and dashes which appear on the radar display in a line emanating radially from just beyond the echo of the aid station. Although racons may be used on both laterally significant and non-laterally significant aids alike, the racon signal itself is for identification purposes only, and therefore carries no lateral significance."
        },
        {
          "id": "b",
          "text": "(b) Racons are also used as bridge marks to mark the best point of passage."
        }
      ]
    },
    "62.54": {
      "id": "62.54",
      "heading": "Ownership identification.",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Ownership identification on private or state aids to navigation is permitted so long as it does not change or hinder an understanding of the meaning of the aid to navigation."
        }
      ]
    },
    "62.63": {
      "id": "62.63",
      "heading": "Recommendations.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) The public may recommend changes to existing aids to navigation, request new aids or the discontinuation of existing aids, and report aids no longer necessary for maritime safety. These recommendations should be sent to the appropriate District Commander."
        },
        {
          "id": "b",
          "text": "(b) Recommendations, requests and reports should be documented with as much information as possible to justify the proposed action. Desirable information includes:"
        },
        {
          "id": "b(1)",
          "text": "(1) Nature of the vessels which transit the area(s) in the question, including type, displacement, draft, and number of passengers and crew."
        },
        {
          "id": "b(2)",
          "text": "(2) Where practicable, the kinds of navigating devices used aboard such vessels (e.g, magnetic or gyro compasses, radio direction finders, radar, electronic charting systems, and searchlights)."
        },
        {
          "id": "b(3)",
          "text": "(3) A chartlet or sketch describing the actual or proposed location of the aid(s), and a description of the action requested or recommended."
        }
      ]
    },
    "62.65": {
      "id": "62.65",
      "heading": "Procedure for reporting defects and discrepancies.",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Mariners should notify the nearest Coast Guard facility immediately of any observed aids to navigation defects or discrepancies."
        },
        {
          "id": "b",
          "text": "(b) The Coast Guard cannot monitor the many thousands of aids in the U.S. Aids to Navigation System simultaneously and continuously. As a result, it is not possible to maintain every aid operating properly and on its charted position at all times. Marine safety will be enhanced if persons finding aids missing, sunk, capsized, damaged, off station, or showing characteristics other than those advertised in the Light List, or other publication, promptly inform the Coast Guard. When making the report to the Coast Guard the mariner should consult the Light List to ensure the correct geographical information is used due to the similarity of names and geographical areas."
        },
        {
          "id": "c",
          "text": "(c) Procedures for reporting defects and discrepancies:"
        },
        {
          "id": "c(1)",
          "text": "(1) Radio messages should be prefixed “Coast Guard” and transmitted directly to a Government shore radio station listed in Chapter three of Radio Navigation Aids Publication, 117, for relay to the relevant District Commander."
        },
        {
          "id": "c(2)",
          "text": "(2) Telephone, e-mail, or facsimile messages may also be used to advise the nearest Coast Guard unit of defects or discrepancies in aids to navigation."
        },
        {
          "id": "c(3)",
          "text": "(3) Via our Web portal at http://www.navcen.uscg.gov."
        }
      ]
    }
  }
}
